import { useCallback } from "react"
import PropTypes from "prop-types"
import { Button, Typography } from "@mui/material"
import ApplicationLogo from "../application-logo"
import { STATUSES } from "modules/platform/constants"

const { REQUESTED, ACTIVE } = STATUSES

const Integration = ({ account, integration, requestIntegration }) => {
  const IntegrationStatus = useCallback(() => {
    const { status } = integration

    const enableIntegration = () => {
      const { id, name } = integration
      requestIntegration(account, id, name)
    }

    if (status === ACTIVE) {
      return (
        <div className="confirm">
          <Typography
            variant="button"
            className="active"
            sx={{
              color: "inherit",
              display: "block",
            }}
          >
Active
          </Typography>
        </div>
      )
    } else if (status === REQUESTED) {
      return <Button color="primary" disabled variant="text" className="confirm">Pending</Button>
    }
    return <Button color="primary" className="confirm" onClick={enableIntegration}>Request</Button>
  }, [account, integration, requestIntegration])

  const { name, description, logoUrl } = integration
  return <div className="app-card integration">
    <ApplicationLogo url={logoUrl} name={name} />
    <div className="header">
      <div className="name-wrapper">
        <div className="name">{name}</div>
      </div>
    </div>
    <div className="body">
      <p className="description">{description}</p>
      {IntegrationStatus()}
    </div>
  </div>
}

Integration.propTypes = {
  account: PropTypes.string.isRequired,
  requestIntegration: PropTypes.func.isRequired,
  integration: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    status: PropTypes.string,
  }),
}

export default Integration
